export default __webpack_public_path__ + "static/media/icons-19.3e134d43.svg";